import React from "react";
import { Typography, Spin } from "antd";
import { ClassroomCard } from "../../component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Classroom.less";
import { useGetStudentBatchesQuery } from "../../redux/services/batches";
import { ROUTE_CLASSROOM_DETAIL } from "../../constant/routes";
import { EmptyCard } from "../../component";

const { Title } = Typography;

const Classroom = () => {
  const navigate = useNavigate();
  const { student_id } = useSelector((state) => state.auth);
  const {
    data: batches,
    error,
    isLoading,
  } = useGetStudentBatchesQuery(student_id);

  const handleCardClick = (batch_id, coaching_id) => {
    navigate(
      ROUTE_CLASSROOM_DETAIL.replace(":batch_id", batch_id).replace(
        ":coaching_id",
        coaching_id
      )
    );
  };

  return (
    <div className='classroom-container'>
      <div className='upcoming-classes'>
        <Title className='title'>Enrolled Classes</Title>
        <Spin spinning={isLoading}>
          {batches && batches?.data?.length > 0 ? (
            batches.data.map((batch) => (
              <ClassroomCard
                key={batch.batch_id}
                coaching_id={batch.coaching_id}
                coachingName={batch.coaching_name}
                subject={batch.subjects.join(", ")} // Convert array to string
                batch={batch.batch_name}
                validTill={batch.valid_till}
                coachingLogo={batch.coaching_logo || undefined} // Default if empty
                onClick={() =>
                  handleCardClick(batch.batch_id, batch.coaching_id)
                }
              />
            ))
          ) : (
            <EmptyCard text={"No Classes Found"} />
          )}
        </Spin>
      </div>
    </div>
  );
};

export default Classroom;
